import { SignalDispatcher } from 'ste-signals';

export const branchEvents = {
  changed: new SignalDispatcher(),
};
